export default {
  data() {
    return {
      // Validação comum - padrão, chamar apenas uma sem []
      nameRules: [
        v => !!v || this.$t('validation.name_required'),
        // v => (v && v.length <= 40) || "Nome deve conter menos de 40 caracteres"
      ],
      arrayRules: [
        v => (v && v.length > 0) || this.$t('validation.required')
      ],
      emailRules: [
        v => !!v || this.$t('validation.email_required'),
        v => /.+@.+\..+/.test(v) || this.$t('validation.email_invalid'),
      ],
      emailNotRequired: [
        v => ((v && /.+@.+\.+/.test(v)) || !v) || this.$t('validation.name_required'),
      ],
      required: [
        v => !!v || this.$t('validation.required'),
      ],
      required_multiple: [(v) => !!v.length || this.$t('validation.required')],

      not_zero: [
        v => !!v && v != '0.00' || this.$t('validation.not_zero'),
      ],
      positive_number_zero: [
        v => v >= 0 || this.$t('validation.positive_number_zero'),
      ],
      ck_motive: [v => !!v && (v >= 10 && v <= 99) || 'Deve ser entre 10 e 99'],
      ck_number: [v => !!v && v.length == 6 || 'Deve ter 6 dígitos. Ex: 000123'],

      cpf: [
        v => !!v || this.$t('validation.cpf.required'),
        v => v && v.length == 14 || this.$t('validation.cpf.length'),
        v => v && this.TestaCPF(v) || this.$t('validation.cpf.invalid'),
      ],
      cnpj: [
        v => !!v || this.$t('validation.cnpj.required'),
        v => v.length == 18 || this.$t('validation.cnpj.length'),
        v => v && this.validarCNPJ(v) || this.$t('validation.cnpj.invalid'),
      ],
    };
  },
  methods: {
    // Validação individual, chamar muliplas dentro de [method(), method(param)]
    ruleRequired(msg) {
      return v => !!v || msg;
    },
    ruleMail() {
      return v => /.+@.+\..+/.test(v) || this.$t('validation.email_invalid');
    },
    ruleMaxLen(max) {
      return v => (v && v.length <= max) || "Máx " + max + " caracteres";
    },
    ruleMinLen(min) {
      return v => (v && v.length >= min) || "Min " + min + " caracteres";
    },
    ruleMatch(value2Match) {
      return v => (v && v == value2Match) || this.$t('validation.match')
    },
    ruleNumberEqualGreaterThan(val) {
      return v => (v != null && v >= val) || this.$t('validation.min') + ' ' + val;
    },
    ruleNumberEqualLessThan(val) {
      return v => (v != null && v <= val) || this.$t('validation.max') + ' ' + val;
    },
    TestaCPF(strCPF) {
      let Soma;
      let Resto;
      Soma = 0;
      strCPF = strCPF.replace(/[^\d]+/g, '')
      if (strCPF == "00000000000") return false;

      for (let i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
      Resto = (Soma * 10) % 11;

      if ((Resto == 10) || (Resto == 11)) Resto = 0;
      if (Resto != parseInt(strCPF.substring(9, 10))) return false;

      Soma = 0;
      for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
      Resto = (Soma * 10) % 11;

      if ((Resto == 10) || (Resto == 11)) Resto = 0;
      if (Resto != parseInt(strCPF.substring(10, 11))) return false;
      return true;
    },
    validarCNPJ(c) {
      var cnpjOK = true

      var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

      if ((c = c.replace(/[^\d]/g, "")).length != 14) { cnpjOK = false; }

      if (/0{14}/.test(c)) { cnpjOK = false; }

      for (var i = 0, n = 0; i < 12; n += c[i] * b[++i]);
      if (c[12] != (((n %= 11) < 2) ? 0 : 11 - n)) { cnpjOK = false; }

      for (var i = 0, n = 0; i <= 12; n += c[i] * b[i++]);
      if (c[13] != (((n %= 11) < 2) ? 0 : 11 - n)) { cnpjOK = false; }

      return cnpjOK
    },
  }
};
